<canvas class="chart-canvas" id="monthly-revenue-chart" height="400"> </canvas>
